module.exports = __webpack_public_path__ + "img/icon_tap_store.f64e8f08.svg";